import { render, staticRenderFns } from "./DentalForm.vue?vue&type=template&id=68ec3ca2&scoped=true&"
import script from "./DentalForm.vue?vue&type=script&lang=js&"
export * from "./DentalForm.vue?vue&type=script&lang=js&"
import style0 from "./DentalForm.vue?vue&type=style&index=0&id=68ec3ca2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec3ca2",
  null
  
)

export default component.exports